<template>
    <div>
        <div v-if="updatecolumn && (column.field === 'flELevel' || column.field === 'elevel')" :key="row.id" style="height: 23px" class="divCenter">
            <span :key="row.id" class="color-box" :style="{ background: getEnevle('color') }" />
            <span :key="row.id" class="text-box">{{ getEnevle('name') }}</span>
        </div>
        <div v-if="column.field === 'operate'">
            <el-link v-if="!row.wfNodeNames" v-pageBtn-lbl="'edit'" :underline="false" @click="editorForm">编辑</el-link>
            <el-link v-pageBtn-lbl="'setting'" :underline="false" @click="fileSetting">设置</el-link>
        </div>
    </div>
</template>
<script>
import { mapGetters } from 'vuex'
export default {
    components: {},
    props: {
        row: {
            type: Object,
            default: function () {
                return {}
            }
        },
        column: {
            type: Object,
            default: function () {
                return {}
            }
        }
    },
    data() {
        return {
            updatecolumn: true,
            enevlelist: []
        }
    },
    computed: {
        ...mapGetters(['loginUser'])
    },
    watch: {},
    created() {
        this.$bus.on('loadEnevlelist', this.loadEnevlelist)
        const list = sessionStorage.getItem(this.loginUser.orgCode + '_LEVEL')
        this.enevlelist = list ? JSON.parse(list) : []
    },
    mounted() {},
    beforeDestroy() {
        this.$bus.off('loadEnevlelist', this.loadEnevlelist)
    },
    methods: {
        fileSetting() {
            this.$bus.emit('fileSetting', this.row)
        },
        editorForm() {
            this.$bus.emit('editorForm', this.row)
        },
        loadEnevlelist() {
            const list = sessionStorage.getItem(this.loginUser.orgCode + '_LEVEL')
            this.enevlelist = list ? JSON.parse(list) : []
            this.updatecolumn = false
            this.$nextTick(() => {
                this.updatecolumn = true
            })
        },
        getEnevle(type) {
            let level = null
            this.enevlelist.forEach((item) => {
                if (this.row.elvVal === item.eLevel || this.row.elevel === item.eName || this.row.flELevel === item.eLevel || this.row.flELevel === item.eName) {
                    level = item
                }
            })
            return level !== null ? (type === 'color' ? level.color : level.eName) : this.row.elevel || this.row.flELevel
        }
    }
}
</script>

<style scoped lang="scss">
.color-box {
    display: inline-block;
    margin-top: 4px;
    margin-right: 5px;
    width: 15px;
    min-width: 15px;
    height: 15px;
}
.text-box {
    flex: 1;
    overflow: inherit;
    text-overflow: inherit;
    text-align: left;
}
.divCenter {
    display: flex;
    padding: 0px 10px;
    justify-content: flex-start;
    overflow: inherit;
    text-overflow: inherit;
}
</style>
